var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "invoiceContent" },
    [
      _c(
        "div",
        { staticClass: "label-container" },
        [
          _c("div", { staticClass: "label-item" }, [
            _c("div", { staticClass: "label-mark" }, [_vm._v("主单号")]),
            _c("div", { staticClass: "label-info" }, [
              _vm._v(_vm._s(_vm.row.mblNo)),
            ]),
          ]),
          _vm.row.containerNumber
            ? _c("div", { staticClass: "label-item" }, [
                _c("div", { staticClass: "label-mark" }, [_vm._v("柜号")]),
                _c("div", { staticClass: "label-info" }, [
                  _vm._v(_vm._s(_vm.row.containerNumber)),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "label-item" }, [
            _c("div", { staticClass: "label-mark" }, [_vm._v("提单件数")]),
            _c("div", { staticClass: "label-info" }, [
              _vm._v(_vm._s(_vm.row.qty)),
            ]),
          ]),
          _c("div", { staticClass: "label-item" }, [
            _c("div", { staticClass: "label-mark" }, [_vm._v("提单重量")]),
            _c("div", { staticClass: "label-info" }, [
              _vm._v(_vm._s(_vm.row.weightKgs)),
            ]),
          ]),
          !_vm.row.isType86
            ? [
                _c("div", { staticClass: "label-item" }, [
                  _c(
                    "div",
                    {
                      staticClass: "label-mark tax",
                      staticStyle: { width: "100px" },
                    },
                    [_vm._v("客户税金范围")]
                  ),
                  _c("div", { staticClass: "number" }, [
                    _vm._v(" " + _vm._s(_vm.row.minTax || 0) + " "),
                    _c("span", { staticClass: "line" }, [_vm._v("-")]),
                    _vm._v(" " + _vm._s(_vm.row.maxTax || 0) + " USD "),
                  ]),
                ]),
                _c("div", { staticClass: "label-item" }, [
                  _c("div", { staticClass: "label-mark" }, [_vm._v("总税金")]),
                  _c(
                    "div",
                    {
                      staticClass: "label-info",
                      staticStyle: {
                        color: "rgb(18, 88, 188)",
                        cursor: "pointer",
                      },
                      attrs: { title: "下载普通发票" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.mdlType ? _vm.sums[19] : _vm.sums[20]) +
                          " "
                      ),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "label-item" }, [
                  _c("div", { staticClass: "label-mark" }, [
                    _vm._v("系统税金"),
                  ]),
                  _vm._v(" " + _vm._s(_vm.systemSum) + " "),
                ]),
                _c("div", { staticClass: "label-item" }, [
                  _c("div", { staticClass: "label-mark" }, [_vm._v("ISF税号")]),
                  _c("div", { staticClass: "label-info" }, [
                    _vm._v(_vm._s(_vm.isfHsCode)),
                  ]),
                ]),
              ]
            : [
                _c("div", { staticClass: "label-item" }, [
                  _c("div", { staticClass: "label-mark" }, [_vm._v("总货值")]),
                  _c("div", { staticClass: "label-info" }, [
                    _vm._v(_vm._s(_vm.grossValue)),
                  ]),
                ]),
              ],
        ],
        2
      ),
      _c(
        "div",
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.invoiceLists.data,
                border: "",
                "show-summary": !_vm.row.isType86,
                width: "100%",
                height: _vm.height,
                "header-cell-style": _vm.headerStyle,
                "cell-style": _vm.cellStyle,
                "summary-method": _vm.getSummaries,
              },
              on: {
                "cell-dblclick": _vm.dblclick,
                "header-click": _vm.headerClick,
                "selection-change": _vm.handleSelectionChange,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  width: "54",
                  fixed: "left",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  width: "54",
                  fixed: "left",
                  align: "center",
                  label: "序号",
                },
              }),
              _vm._l(_vm.invoiceLists.fileds, function (item, index) {
                return _c("el-table-column", {
                  key: index,
                  attrs: {
                    prop: item.filed,
                    label: item.text,
                    width: item.width,
                    fixed: item.fixed,
                    resizable: false,
                    align: "center",
                    "header-align": "center",
                    "show-overflow-tooltip": true,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.isEdit.length > 0 &&
                            scope.row.isEdit.indexOf(item.filed) > -1
                              ? _c("el-input", {
                                  ref: "input",
                                  refInFor: true,
                                  attrs: {
                                    focus: "",
                                    placeholder: "请输入内容",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.blur(scope.row)
                                    },
                                    blur: function ($event) {
                                      return _vm.blur(scope.row)
                                    },
                                  },
                                  model: {
                                    value: scope.row[item.filed],
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, item.filed, $$v)
                                    },
                                    expression: "scope.row[item.filed]",
                                  },
                                })
                              : item.filed === "rate"
                              ? [
                                  _c("div", [
                                    _vm._v(" B"),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: { "margin-left": "10px" },
                                      },
                                      [_vm._v(_vm._s(scope.row.baseRate))]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        color: "rgb(18, 88, 188)",
                                      },
                                    },
                                    [
                                      _vm._v(" A"),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px",
                                          },
                                        },
                                        [_vm._v(_vm._s(scope.row.addRate))]
                                      ),
                                    ]
                                  ),
                                ]
                              : item.filed === "sellerAddress"
                              ? _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      effect: "dark",
                                      content: scope.row[item.filed],
                                      placement: "bottom",
                                    },
                                  },
                                  [
                                    item.filed === "sellerAddress"
                                      ? _c("img", {
                                          attrs: {
                                            src: require("@/assets/images/bill/address3.png"),
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                )
                              : _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "justify-content": "center",
                                      "align-items": "center",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        $event.stopPropagation()
                                        return _vm.cellClick(
                                          scope.row,
                                          scope.column
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(scope.row[item.filed]) + " "
                                    ),
                                  ]
                                ),
                          ]
                        },
                      },
                      {
                        key: "header",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "flex_c_c" },
                              [
                                _vm._v(" " + _vm._s(scope.column.label) + " "),
                                _vm.whiteList.indexOf(item.filed) > -1 &&
                                _vm.headFixed.indexOf(item.filed) === -1
                                  ? _c("svg-icon", {
                                      attrs: {
                                        className: "icon",
                                        iconClass: "edit",
                                      },
                                    })
                                  : _vm._e(),
                                _vm.whiteList.indexOf(item.filed) > -1 &&
                                _vm.headFixed.indexOf(item.filed) > -1
                                  ? _c("svg-icon", {
                                      attrs: {
                                        className: "icon",
                                        iconClass: "not-edit",
                                      },
                                    })
                                  : _vm._e(),
                                item.showTip
                                  ? [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            tabindex: 2000,
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("div", {
                                            attrs: { slot: "content" },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                item.headerCentent
                                              ),
                                            },
                                            slot: "content",
                                          }),
                                          _c("img", {
                                            attrs: {
                                              src: require("@/assets/images/table/question.png"),
                                              alt: "",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              !_vm.row.isType86
                ? _c("el-table-column", {
                    attrs: {
                      prop: "remark",
                      label: "备注",
                      fixed: "right",
                      align: "center",
                      "header-align": "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "bottom-end",
                                    width: "426",
                                    trigger: "click",
                                  },
                                },
                                [
                                  !scope.row.remark
                                    ? _c("img", {
                                        staticStyle: { cursor: "pointer" },
                                        attrs: {
                                          slot: "reference",
                                          src: require("@/assets/images/bill/edit2.png"),
                                        },
                                        slot: "reference",
                                      })
                                    : _c("img", {
                                        staticStyle: { cursor: "pointer" },
                                        attrs: {
                                          slot: "reference",
                                          src: require("@/assets/images/bill/message.png"),
                                        },
                                        slot: "reference",
                                      }),
                                  _c("div", { staticClass: "remark-area" }, [
                                    _c("div", { staticClass: "title" }, [
                                      _c("p", { staticClass: "lable" }, [
                                        _vm._v("备注内容"),
                                      ]),
                                      _c("p", [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "copy",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleCopy(
                                                  scope.row.remark
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                "vertical-align": "-4px",
                                              },
                                              attrs: {
                                                src: require("@/assets/images/bill/copy1.png"),
                                              },
                                            }),
                                            _vm._v("复制 "),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "content" },
                                      [
                                        _c("el-input", {
                                          attrs: { rows: 8, type: "textarea" },
                                          model: {
                                            value: scope.row.remark,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "remark", $$v)
                                            },
                                            expression: "scope.row.remark",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1634643617
                    ),
                  })
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      !_vm.row.isType86
        ? _c("div", { staticClass: "footer" }, [
            _c("div", { staticClass: "tableFooter" }, [
              _c("span", { staticClass: "selection" }, [
                _vm._v(" 已选择 "),
                _c("span", { staticClass: "selection_num" }, [
                  _vm._v(_vm._s(_vm.mutiSelection.length)),
                ]),
                _vm._v(" 项"),
              ]),
              _c(
                "div",
                {
                  staticClass: "btn",
                  staticStyle: { "margin-left": "10px" },
                  on: { click: _vm.merge },
                },
                [
                  _c("svg-icon", {
                    attrs: { className: "icon", iconClass: "merge" },
                  }),
                  _vm._v("合并 "),
                ],
                1
              ),
              _c("div", { staticClass: "btn", on: { click: _vm.deleteRow } }, [
                _c("i", { staticClass: "el-icon-delete" }),
                _vm._v("删除 "),
              ]),
            ]),
            _c("div", { staticClass: "btn1", on: { click: _vm.cancel } }, [
              _vm._v("取消"),
            ]),
            _c("div", { staticClass: "btn1", on: { click: _vm.save } }, [
              _vm._v("暂存"),
            ]),
            _vm.$store.state.invoiceLoop?.caches.length > 0
              ? _c("div", { staticClass: "btn2", on: { click: _vm.prev } }, [
                  _vm._v(" 上一步 "),
                ])
              : _vm._e(),
            _c("div", { staticClass: "btn2", on: { click: _vm.ok } }, [
              _vm._v("接受"),
            ]),
            _c("div", { staticClass: "btn2", on: { click: _vm.refuse } }, [
              _vm._v("拒绝"),
            ]),
          ])
        : _c("div", { staticClass: "type86_footer flex_c_c" }, [
            _c(
              "div",
              { staticClass: "cancel flex_c_c", on: { click: _vm.cancel } },
              [_vm._v("取消")]
            ),
            _c(
              "div",
              { staticClass: "refuse flex_c_c", on: { click: _vm.refuse } },
              [_vm._v("拒绝")]
            ),
            _c("div", { staticClass: "ok flex_c_c", on: { click: _vm.ok } }, [
              _vm._v("接受"),
            ]),
          ]),
      _c("ProductDialog", {
        attrs: { dialogVisible: _vm.dialogVisible1 },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible1 = false
          },
          ok: _vm.ok1,
        },
      }),
      _c("TaxDialog", {
        attrs: { dialogVisible: _vm.dialogVisible2 },
        on: {
          cancel: function ($event) {
            _vm.dialogVisible2 = false
          },
          ok: _vm.ok2,
        },
      }),
      _c("MergeInvoiceDialog", {
        attrs: {
          dialogVisible: _vm.dialogVisible4,
          productRow: _vm.mutiSelection,
        },
        on: {
          cancer: function ($event) {
            _vm.dialogVisible4 = false
          },
          ok: _vm.ok3,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }